<template>
    <div class="FileUploadPane container-fluid">
        <div class="row">
            <div class="col-md-4">
                <div class="paper">
                    <h4 class="center-text">Batch Service Detail Report</h4>
                    <b-form @submit="UploadBatchServiceDetailReport" ref="form-uploadbatchservicedetailreport">
                        <div class="form-group">
                            <label>Info:</label>
                            <p>RUHS-BH's Report Distribution System allows you to export a report called <span class="bold">PVD 2002 Batch Service Detail by PVD</span>.  That report can be imported here, which allows centralized analysis of claims submitted to RUHS-BH.  Because the report is grouped by date of service, the report should be ran from the start of the last full fiscal year to the current date.  This ensures that all recent claims will be included in each new report.  The report should be exported as an excel file.</p>
                        </div>
                        <div class="form-group">
                            <label>File:</label>
                            <b-form-file class="form-control"
                                         name="FormFile"
                                         v-model="FileSelections.BatchServiceDetailReport"
                                         accept=".xls"
                                         no-drop
                                         drop-placeholder="Drop file here...">

                            </b-form-file>
                        </div>
                        <b-button type="submit" variant="success" class="form-control"><font-awesome-icon :icon="['fa', 'file-upload']" /> UPLOAD</b-button>
                    </b-form>
                </div>
            </div>
            <div class="col-md-4">
                <div class="paper">
                    <h4 class="center-text">Client Authorizations Report</h4>
                    <b-form @submit="UploadClientAuthorizationsReport" ref="form-uploadclientauthorizationsreport">
                        <div class="form-group">
                            <label>Info:</label>
                            <p>RUHS-BH's Report Distribution System allows you to export a report called <span class="bold">PVD 7030 Service Authorization Entries</span>.  That report can be imported here, which allows Oliver to sync it's client authorizations data with data from RUHS-BH.</p>
                        </div>
                        <div class="form-group">
                            <label>File:</label>
                            <b-form-file class="form-control"
                                         name="FormFile"
                                         v-model="FileSelections.ClientAuthoriztionsReport"
                                         accept=".xls"
                                         no-drop
                                         drop-placeholder="Drop file here...">

                            </b-form-file>
                        </div>
                        <b-button type="submit" variant="success" class="form-control"><font-awesome-icon :icon="['fa', 'file-upload']" /> UPLOAD</b-button>
                    </b-form>
                </div>
            </div>
           
        </div>

        <div class="row">
            <div class="col-md-4">
                <div class="paper">
                    <h4 class="center-text">Lock Notes</h4>
                    <b-form @submit="UploadClaimsLock" ref="form-uploadclaimslock">
                        <div class="form-group">
                            <label>Info:</label>
                            <p>Upload a list of Document Ids for documents that have been processed and need to be locked.  File should be a list of Document IDs, each on it's own line.'</p>
                        </div>
                        <div class="form-group">
                            <label>File:</label>
                            <b-form-file class="form-control"
                                         name="FormFile"
                                         v-model="FileSelections.UploadClaimsLock"
                                         accept=".txt"
                                         no-drop
                                         drop-placeholder="Drop file here...">

                            </b-form-file>
                        </div>
                        <div class="form-group">
                            <label>Billed To:</label>
                            <input type="text" name="BilledTo" class="form-control" required />
                        </div>
                        
                        <b-button type="submit" variant="success" class="form-control"><font-awesome-icon :icon="['fa', 'file-upload']" /> UPLOAD</b-button>
                    </b-form>
                </div>
            </div>
            <div class="col-md-4">
                <div class="paper">
                    <h4 class="center-text">Unlock Notes</h4>
                    <b-form @submit="UploadClaimsUnlock" ref="form-uploadclaimsunlock">
                        <div class="form-group">
                            <label>Info:</label>
                            <p>Upload a list of Document Ids for documents that have been processed and need to be unlocked.  File should be a list of Document IDs, each on it's own line.'</p>
                        </div>
                        <div class="form-group">
                            <label>File:</label>
                            <b-form-file class="form-control"
                                         name="FormFile"
                                         v-model="FileSelections.UploadClaimsUnlock"
                                         accept=".txt"
                                         no-drop
                                         drop-placeholder="Drop file here...">

                            </b-form-file>
                        </div>
                        <b-button type="submit" variant="success" class="form-control"><font-awesome-icon :icon="['fa', 'file-upload']" /> UPLOAD</b-button>
                    </b-form>
                </div>
            </div>
            <div class="col-md-4">
                <div class="paper">
                    <h4 class="center-text">Suppress / Unsuppress Claims</h4>
                    <b-form @submit="ManageSuppression" ref="form-uploadsuppression">
                        <div class="form-group">
                            <label>Info:</label>
                            <p>Upload a list of Document Ids for documents that need to be supressed (ignored by billing systems) or un-supressed.'</p>
                        </div>
                        <div class="form-group">
                            <label>Action:</label>
                            <select name="Action" class="form-control" required>
                                <option value="Suppress">Suppress</option>
                                <option value="Un-Suppress">Un-Suppress</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Suppression Reason:</label>
                            <input type="text" name="Reason" class="form-control" required />
                        </div>
                        <div class="form-group">
                            <label>File:</label>
                            <b-form-file class="form-control"
                                         name="FormFile"
                                         v-model="FileSelections.SuppressionManagement"
                                         accept=".txt"
                                         no-drop
                                         drop-placeholder="Drop file here...">

                            </b-form-file>
                        </div>
                        <b-button type="submit" variant="success" class="form-control"><font-awesome-icon :icon="['fa', 'file-upload']" /> UPLOAD</b-button>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components

    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faFileUpload } from '@fortawesome/free-solid-svg-icons';
    library.add(faFileUpload);

    //mixins

    export default {

        props: [],
        data: function () {
            return {
                FileSelections: {
                    BatchServiceDetailReport: {},
                    ClientAuthorizationsReport: {},
                    UploadClaimsLock: {},
                    UploadClaimsUnlock: {},
                    SuppressionManagement: {},
                }
            };
        },
        methods: {
            

            //////////////////////////
            //  API CONNECTIONS
            //////////////////////////

            //Batch Service Detail Report
            UploadBatchServiceDetailReport(e) {
                e.preventDefault();
                let form = this.$refs['form-uploadbatchservicedetailreport'];
                let formData = new FormData(form);
                this.$MasterAPI.ExecuteRequest("PATCH", "MentalHealth/Billing/Avatar/BatchServiceDetailReport", formData, this.UploadBatchServiceDetailReportSuccess,()=>{}, true);
            },
            UploadBatchServiceDetailReportSuccess(response) {
                this.FileSelections.BatchServiceDetailReport = "";
                alert("The Batch Service Detail Report has been successfully uploaded.")
            },

            //Client Authorizations Report
            UploadClientAuthorizationsReport(e) {
                e.preventDefault();
                let form = this.$refs['form-uploadclientauthorizationsreport'];
                let formData = new FormData(form);
                this.$MasterAPI.ExecuteRequest("PATCH", "MentalHealth/Billing/ClientServiceAuthorizations/RUHSPvd7030ClientAuthorizations", formData, this.UploadClientAuthorizationsReportSuccess, () => { }, true);
            },
            UploadClientAuthorizationsReportSuccess(response) {
                this.FileSelections.ClientAuthorizationsReport = "";
                alert("The Client Service Authorizations Report has been successfully uploaded. " + response.data.data.TotalRecordsImported + "/" + response.data.data.TotalRecordsFromReport + " were imported.");
            },

            //Claims Lock
            UploadClaimsLock(e) {
                e.preventDefault();
                let form = this.$refs['form-uploadclaimslock'];
                let formData = new FormData(form);
                this.$MasterAPI.ExecuteRequest("PATCH", "MentalHealth/Billing/Claims/LockProcessedClaims", formData, this.UploadClaimsLockSuccess, () => { }, true);
            },
            UploadClaimsLockSuccess(response) {
                this.FileSelections.UploadClaimsLock = "";
                alert("The targeted Documents have been locked and can not be edited.");
            },

            //Claims Unlock
            UploadClaimsUnlock(e) {
                e.preventDefault();
                let form = this.$refs['form-uploadclaimsunlock'];
                let formData = new FormData(form);
                this.$MasterAPI.ExecuteRequest("PATCH", "MentalHealth/Billing/Claims/UnlockClaims", formData, this.UploadClaimsUnlockSuccess, () => { }, true);
            },
            UploadClaimsUnlockSuccess(response) {
                this.FileSelections.UploadClaimsUnlock = "";
                alert("The targeted Documents have been unlocked and can now be edited.");
            },

            //Suppression Management
            ManageSuppression(e) {
                e.preventDefault();
                let form = this.$refs['form-uploadsuppression'];
                let formData = new FormData(form);
                this.$MasterAPI.ExecuteRequest("PATCH", "MentalHealth/Billing/Claims/ManageClaimSuppression", formData, this.ManageSuppressionSuccess, () => { }, true);
            },
            ManageSuppressionSuccess(response) {
                this.FileSelections.SuppressionManagement = "";
                alert("The targeted Documents have had their suppression modified");
            },
            
            //////////////////////////
            //  MISC METHODS
            //////////////////////////
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            
        },
        computed: {

        },
        mounted() {
            
        }
    }
</script>

<style scoped>
</style>